import { Injectable } from '@angular/core';
import { MoneyDTO, FieldConfigDTO } from '../../../../../system/system-dtos';
import { DataType } from '../../data-type-component';
import { CurrencyDTO } from '../../lottomart/model/lottomart-model';

@Injectable()
export class MoneyService {
  formatMoney(money: MoneyDTO, moneyFormat: string): string {
    let displayMoneyValue = '';
    if (money) {
      // displayMoneyValue = this.getFullValue(money);
      if (moneyFormat) {
        if (moneyFormat === 'jackpotValue') {
          displayMoneyValue = this.getJackpotValue(money);
        } else if (moneyFormat === 'ticketPrice') {
          displayMoneyValue = this.getTicketPrice(money);
        } else if (moneyFormat === 'transaction') {
          displayMoneyValue = this.getTicketPrice(money);
        } else if (moneyFormat === 'fullValue') {
          displayMoneyValue = this.getFullValue(money);
        } else {
          displayMoneyValue = this.getFullValue(money);
        }
      } else {
        displayMoneyValue = this.getFullValue(money);
      }
    } else {
      displayMoneyValue = 'free';
    }
    return displayMoneyValue;
  }

  getTicketPrice(money: MoneyDTO): string {
    let displayValue: string;
    if (money === undefined) {
      displayValue = 'free';
    } else if (money.currency) {
      if (money.currency.decimalPlaces > 0) {
        displayValue = (money.value / 10 ** money.currency.decimalPlaces).toFixed(money.currency.decimalPlaces);
      } else {
        displayValue = money.value.toFixed(0);
      }
    } else if (money.value !== undefined && money.value !== null) {
      console.error('Money did not have a currency', money);
      displayValue = money.value.toFixed(0);
    } else {
      console.error('Money did not have a currency or value', money);
      displayValue = '0';
    }
    return displayValue;
  }

  getFullValue(money: MoneyDTO): string {
    let displayValue: string;
    if (!money) {
      displayValue = 'free';
    } else if (money.currency && money.currency.decimalPlaces > 0) {
      const val: number = money.value / 10 ** money.currency.decimalPlaces; // .toFixed(money.currency.decimalPlaces);
      // displayValue = val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
      displayValue = val.toLocaleString(undefined, {
        minimumFractionDigits: money.currency.decimalPlaces,
        maximumFractionDigits: money.currency.decimalPlaces,
      });
    } else {
      displayValue = money.value ? money.value.toLocaleString() : null;
    }

    return displayValue;
  }

  getJackpotValue(money: MoneyDTO): string {
    let displayValue: string;
    if (!money) {
      displayValue = 'free';
    } else if (money.currency && money.currency.decimalPlaces > 0) {
      if (money.value / 10 ** money.currency.decimalPlaces / 1000000 >= 1.0) {
        displayValue = `${(money.value / 10 ** money.currency.decimalPlaces / 1000000).toFixed(0)} M`;
      } else {
        displayValue = `${(money.value / 10 ** money.currency.decimalPlaces / 1000).toFixed(0)} K`;
      }
    } else if (money.value / 1000000 >= 1.0) {
      displayValue = `${(money.value / 1000000).toFixed(0)} M`;
    } else {
      displayValue = `${(money.value / 1000).toFixed(0)} M`;
    }
    return displayValue;
  }

  zeroMoney(currency: CurrencyDTO): MoneyDTO {
    return this.create(0, currency);
  }

  create(value: number, currency: CurrencyDTO): MoneyDTO {
    return { value, currency };
  }

  moneyConfig(name: string): FieldConfigDTO {
    return {
      label: null,
      type: DataType.money,
      name,
      moneyFormat: 'fullValue',
      decimalPlaces: 0,
    };
  }
}
